export default "assets/images/icons/contact-mail-967bf52a.svg";